import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.ROOT_API_WEERSTATION,
});

export default instance;



// WEBPACK FOOTER //
// ./src/api/weerstation/axios.js